export enum ModuleKey {
  Whiteboards = "whiteboards",
  Tasks = "tasks",
  Kpis = "kpis",
  Badges = "badges",
  Gif = "gif",
  Tags = "tags",
  Reflections = "reflections",
  PlatformIntelligence = "platform-intelligence",
}
export enum ModuleFlag {
  Whiteboards = "module-whiteboards",
  Tasks = "module-tasks",
  Kpis = "module-kpis",
  Badges = "module-badges",
  Gifs = "module-gifs",
  Tags = "module-tags",
  Reflections = "module-reflections",
  PlatformIntelligence = "module-platform-intelligence",
}
